// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yH9qL2iGJb {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.yH9qL2iGJb h4 {
  line-height: 3em;
}
.yH9qL2iGJb .m4d7ywOiOk {
  float: left;
  width: 100%;
}
.yH9qL2iGJb .PAQLBxASKm {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.yH9qL2iGJb .PAQLBxASKm:hover {
  cursor: pointer;
}
.yH9qL2iGJb .PAQLBxASKm:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.e2BWOwATCX .g9fyrCdBO4:focus {
  outline: none;
}
.e2BWOwATCX .g9fyrCdBO4.a5aa8DXQGe.mxWyAjAtsO {
  background: #375A88;
}
.e2BWOwATCX .g9fyrCdBO4.a5aa8DXQGe.mxWyAjAtsO span {
  color: #fff;
}
.e2BWOwATCX .mxWyAjAtsO {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.e2BWOwATCX .mxWyAjAtsO:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.e2BWOwATCX input {
  height: 38px;
  min-width: 220px;
}
.PAQLBxASKm.sMPsRJBvXf {
  background: #410102;
}
.PAQLBxASKm.Efrjm6a4bn {
  background: #911318;
}
.PAQLBxASKm.Ep5yF5MDkO {
  background: #D8293B;
}
.PAQLBxASKm.MkXGJ8KaLw {
  background: #F2373C;
}
.PAQLBxASKm.p0eHFVy7hM {
  background: #FC4448;
}
.PAQLBxASKm.jKVbIZiukh {
  background: #ED535E;
}
.PAQLBxASKm.pA12jzdtBv {
  background: #E34926;
}
.PAQLBxASKm.Y7fMoawm41 {
  background: #FC562B;
}
.PAQLBxASKm.w_X7rzpP6b {
  background: #FC6722;
}
.PAQLBxASKm.QiKTLfmiNg {
  background: #FD7F24;
}
.PAQLBxASKm.f6hpxwY3yJ {
  background: #FD8D26;
}
.PAQLBxASKm.riqi6au5Z8 {
  background: #EC9C3E;
}
.PAQLBxASKm.daBTT5lfmB {
  background: #0e673a;
}
.PAQLBxASKm.GWE0UNKuEe {
  background: #208740;
}
.PAQLBxASKm.PBkBjj4z_8 {
  background: #239718;
}
.PAQLBxASKm.ZtPR3CDHiz {
  background: #55A84D;
}
.PAQLBxASKm.kU4NckRbsE {
  background: #4BBE5A;
}
.PAQLBxASKm.NjVrBAj74n {
  background: #0CCA6A;
}
.PAQLBxASKm.lI2mdR9v1J {
  background: #0A3C64;
}
.PAQLBxASKm.H2IKCxGGWY {
  background: #0d487a;
}
.PAQLBxASKm.yBSKBFyAa4 {
  background: #10538d;
}
.PAQLBxASKm.JVfmzWE5C9 {
  background: #115A99;
}
.PAQLBxASKm.tzsffF18n0 {
  background: #3387E2;
}
.PAQLBxASKm.ptsTS2xm7L {
  background: #1BA9CF;
}
.PAQLBxASKm.YsuhPgDmQE {
  background: #d27c02;
}
.PAQLBxASKm.nzR84wfPPm {
  background: #fb9402;
}
.PAQLBxASKm.fedNJQWeFe {
  background: #FD9B30;
}
.PAQLBxASKm.flLL4pAwYG {
  background: #FDBE2D;
}
.PAQLBxASKm.dJwlbciPTA {
  background: #FED831;
}
.PAQLBxASKm.Vzc8l6U27N {
  background: #FFFD38;
}
.PAQLBxASKm.zxMxuqK608 {
  background: #2D215C;
}
.PAQLBxASKm.EeafIbiJHb {
  background: #483C83;
}
.PAQLBxASKm.S1lNmtE1oA {
  background: #58518d;
}
.PAQLBxASKm.mVYqoHwMjP {
  background: #7068A9;
}
.PAQLBxASKm.QJdJpPEryA {
  background: #7f78b2;
}
.PAQLBxASKm.uPn29KFBfZ {
  background: #8f88bc;
}
.PAQLBxASKm.FjUXcHEmmj {
  background: #000;
}
.PAQLBxASKm.nONl3MC6fp {
  background: #282626;
}
.PAQLBxASKm.i68gpSYOD2 {
  background: #242222;
}
.PAQLBxASKm.BcWhZtQ7n5 {
  background: #353838;
}
.PAQLBxASKm.t8FVqzEEUO {
  background: #666;
}
.PAQLBxASKm.MarhiyBCe2 {
  background: #999;
}
.wHkg0jCcth {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.wHkg0jCcth .RLiJh1tpUa {
  display: none;
}
.yVQYqZ33MQ {
  container-type: inline-size;
}
.YCOkDaF2wx {
  display: flex;
  align-items: center;
  background-color: #F2F2F2;
  text-align: center;
  font-size: clamp(10px, 4cqw, 16px);
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  min-height: 344px;
}
.YCOkDaF2wx .sDoP9v51Rl {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #959499;
}
.YCOkDaF2wx .IiPY20pBSi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: inherit;
}
.YCOkDaF2wx .IiPY20pBSi .ep93EdQUzG {
  margin: 0;
}
.YCOkDaF2wx .IiPY20pBSi .Nx_DkPRhS9 {
  margin: 0;
  font-size: 1em;
  font-weight: bold;
  text-transform: uppercase;
  text-align: left;
}
.YCOkDaF2wx .IiPY20pBSi .yd9D6k7guh {
  text-align: start;
  margin: 0;
  font-size: 12px;
  line-height: 18px;
  color: #313033;
}
.rz4O60Bvk4 {
  font-size: 20px;
  flex-direction: column;
  justify-content: center;
}
.rz4O60Bvk4 .IiPY20pBSi .ep93EdQUzG {
  margin: auto;
}
.rz4O60Bvk4 .IiPY20pBSi .Nx_DkPRhS9 {
  margin: revert;
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `yH9qL2iGJb`,
	"color-row": `m4d7ywOiOk`,
	"color-tile": `PAQLBxASKm`,
	"picker-component": `e2BWOwATCX`,
	"picker-element": `g9fyrCdBO4`,
	"active": `a5aa8DXQGe`,
	"btn": `mxWyAjAtsO`,
	"red-1": `sMPsRJBvXf`,
	"red-2": `Efrjm6a4bn`,
	"red-3": `Ep5yF5MDkO`,
	"red-4": `MkXGJ8KaLw`,
	"red-5": `p0eHFVy7hM`,
	"red-6": `jKVbIZiukh`,
	"orange-1": `pA12jzdtBv`,
	"orange-2": `Y7fMoawm41`,
	"orange-3": `w_X7rzpP6b`,
	"orange-4": `QiKTLfmiNg`,
	"orange-5": `f6hpxwY3yJ`,
	"orange-6": `riqi6au5Z8`,
	"green-1": `daBTT5lfmB`,
	"green-2": `GWE0UNKuEe`,
	"green-3": `PBkBjj4z_8`,
	"green-4": `ZtPR3CDHiz`,
	"green-5": `kU4NckRbsE`,
	"green-6": `NjVrBAj74n`,
	"blue-1": `lI2mdR9v1J`,
	"blue-2": `H2IKCxGGWY`,
	"blue-3": `yBSKBFyAa4`,
	"blue-4": `JVfmzWE5C9`,
	"blue-5": `tzsffF18n0`,
	"blue-6": `ptsTS2xm7L`,
	"yellow-1": `YsuhPgDmQE`,
	"yellow-2": `nzR84wfPPm`,
	"yellow-3": `fedNJQWeFe`,
	"yellow-4": `flLL4pAwYG`,
	"yellow-5": `dJwlbciPTA`,
	"yellow-6": `Vzc8l6U27N`,
	"purple-1": `zxMxuqK608`,
	"purple-2": `EeafIbiJHb`,
	"purple-3": `S1lNmtE1oA`,
	"purple-4": `mVYqoHwMjP`,
	"purple-5": `QJdJpPEryA`,
	"purple-6": `uPn29KFBfZ`,
	"black-1": `FjUXcHEmmj`,
	"black-2": `nONl3MC6fp`,
	"black-3": `i68gpSYOD2`,
	"black-4": `BcWhZtQ7n5`,
	"black-5": `t8FVqzEEUO`,
	"black-6": `MarhiyBCe2`,
	"picker-theme": `wHkg0jCcth`,
	"arrow-regular": `RLiJh1tpUa`,
	"empty-review-container": `yVQYqZ33MQ`,
	"empty-review": `YCOkDaF2wx`,
	"empty-review__icon": `sDoP9v51Rl`,
	"empty-review__root": `IiPY20pBSi`,
	"empty-review__createBtn": `ep93EdQUzG`,
	"empty-review__title": `Nx_DkPRhS9`,
	"empty-review__content": `yd9D6k7guh`,
	"empty-review--reviewPage": `rz4O60Bvk4`
};
export default ___CSS_LOADER_EXPORT___;
